(function () {
  'use strict';

  var MAX_PRODUCTS = 4;
  var REBUY_FLYOUT = 'div#fcd-drawer';
  var REBUY_WIDGET = '[data-rebuy-component="cross-sell-widget"]';
  var REBUY_BODY   = '.fcd-body';
  var WIDGET_ID    = 'fccs-widget';
  var RULES_URL    = '/cdn/shop/t/160048382171/assets/cross-sell-rules.json';

  var injected       = false;
  var rules          = null;
  var innerObs       = null;
  var lastHandles    = '';
  var cachedProducts = null;
  var lockedPicks    = null;
  var productCache   = {};

  function injectStyles() {
    if (document.getElementById('fccs-styles')) return;
    var s = document.createElement('style');
    s.id = 'fccs-styles';
    s.textContent = [
      REBUY_WIDGET + '{display:none!important}',
      '#fccs-widget{background:#fff;padding:16px 0 0}',
      '#fccs-widget .fccs-title{font-size:13px;font-weight:500;color:#4a4a4a;text-align:center;margin:0 0 12px;letter-spacing:.02em}',
      '#fccs-widget .fccs-item{display:grid;grid-template-columns:72px 1fr auto;align-items:center;gap:12px;padding:12px 16px;border-top:1px solid #f2f2f2}',
      '#fccs-widget .fccs-item:first-of-type{border-top:1px solid #ebebeb}',
      '#fccs-widget .fccs-img-link{display:block;width:72px;height:72px;flex-shrink:0}',
      '#fccs-widget .fccs-img{width:72px;height:72px;border-radius:6px;object-fit:cover;display:block;background:#f7f7f7}',
      '#fccs-widget .fccs-info{display:flex;flex-direction:column;gap:5px;min-width:0}',
      '#fccs-widget .fccs-name{font-size:12.5px;font-weight:400;color:#1a1a1a;line-height:1.4;text-decoration:none;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden}',
      '#fccs-widget .fccs-name:hover{text-decoration:underline}',
      '#fccs-widget .fccs-prices{display:flex;align-items:center;gap:5px}',
      '#fccs-widget .fccs-price{font-size:13px;font-weight:500;color:#1a1a1a}',
      '#fccs-widget .fccs-compare{font-size:12px;color:#c0392b;text-decoration:line-through}',
      '#fccs-widget .fccs-select-wrap{position:relative;width:100%;margin-top:4px}',
      '#fccs-widget .fccs-select-wrap::after{content:"";position:absolute;right:8px;top:40%;transform:translateY(-50%);width:0;height:0;border-left:4px solid transparent;border-right:4px solid transparent;border-top:5px solid #1a1a1a;pointer-events:none}',
      '#fccs-widget .fccs-select{display:block;font-size:12px;color:#1a1a1a;border:1px solid #d0d0d0;border-radius:5px;padding:5px 24px 5px 8px;background:#fff;cursor:pointer;width:100%;appearance:none;-webkit-appearance:none}',
      '#fccs-widget .fccs-btn-col{display:flex;flex-direction:column;align-items:flex-end;gap:6px;min-width:72px}',
      '#fccs-widget .fccs-btn{height:34px;min-width:72px;padding:0 14px;border-radius:5px;font-size:12.5px;font-weight:500;cursor:pointer;border:none;transition:background .15s,transform .1s,opacity .15s;white-space:nowrap;text-align:center}',
      '#fccs-widget .fccs-btn-add{background:#1d6f42;color:#fff}',
      '#fccs-widget .fccs-btn-add:hover{background:#165c36}',
      '#fccs-widget .fccs-btn-add:active{transform:scale(.97)}',
      '#fccs-widget .fccs-btn-selected{background:#fff;color:#1d6f42;border:1.5px solid #1d6f42;cursor:default;pointer-events:none}',
      '#fccs-widget .fccs-btn-loading{opacity:.45;pointer-events:none}',
      '#fccs-widget .fccs-skel{background:linear-gradient(90deg,#f5f5f5 25%,#ebebeb 50%,#f5f5f5 75%);background-size:200% 100%;animation:fccs-shimmer 1.4s infinite;border-radius:4px}',
      '@keyframes fccs-shimmer{0%{background-position:200% 0}100%{background-position:-200% 0}}',
    ].join('');
    document.head.appendChild(s);
  }

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2).replace(/\.00$/, '');
  }

  function pickRandomOnce(arr, n) {
    return arr.slice().sort(function () { return Math.random() - 0.5; }).slice(0, n);
  }

  function loadRules(cb) {
    if (rules) { cb(rules); return; }
    fetch(window.FCCS_RULES_URL || RULES_URL)
      .then(function (r) { return r.json(); })
      .then(function (d) { rules = d; cb(rules); })
      .catch(function () { cb({ default: [] }); });
  }

  function getCart(cb) {
    if (window._fcdCart) { cb(window._fcdCart); return; }
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(cb)
      .catch(function () { cb({ items: [] }); });
  }

  function fetchProducts(handles, cb) {
    if (!handles.length) { cb([]); return; }
    var results   = [];
    var remaining = handles.length;
    handles.forEach(function (handle) {
      if (productCache[handle]) {
        results.push(productCache[handle]);
        if (--remaining === 0) cb(results);
        return;
      }
      fetch('/products/' + handle + '.js')
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (p) {
          if (p) { productCache[handle] = p; results.push(p); }
        })
        .catch(function () {})
        .finally(function () { if (--remaining === 0) cb(results); });
    });
  }

  function skeleton() {
    var rows = '';
    for (var i = 0; i < 3; i++) {
      rows += '<div class="fccs-item">' +
        '<div class="fccs-skel" style="width:72px;height:72px;border-radius:6px"></div>' +
        '<div class="fccs-info">' +
          '<div class="fccs-skel" style="height:12px;width:90%;margin-bottom:5px"></div>' +
          '<div class="fccs-skel" style="height:12px;width:65%;margin-bottom:8px"></div>' +
          '<div class="fccs-skel" style="height:12px;width:35%"></div>' +
        '</div>' +
        '<div class="fccs-btn-col"><div class="fccs-skel" style="width:72px;height:34px;border-radius:5px"></div></div>' +
      '</div>';
    }
    return '<p class="fccs-title">You May Also Like</p>' + rows;
  }

  function buildCard(product, inCart) {
    var variants   = product.variants;
    var firstAvail = variants.find(function (v) { return v.available; }) || variants[0];
    var hasMulti   = variants.length > 1;
    var price      = formatMoney(firstAvail.price);
    var compare    = firstAvail.compare_at_price && firstAvail.compare_at_price > firstAvail.price
                       ? formatMoney(firstAvail.compare_at_price) : '';
    var img        = product.featured_image || '';

    var selectHtml = '';
    if (hasMulti) {
      var opts = variants.map(function (v) {
        return '<option value="' + v.id + '"' + (!v.available ? ' disabled' : '') + '>' +
          v.title + (v.available ? '' : ' – Sold out') + '</option>';
      }).join('');
      selectHtml = '<div class="fccs-select-wrap"><select class="fccs-select" data-variant-select>' + opts + '</select></div>';
    }

    var btnHtml = inCart
      ? '<button class="fccs-btn fccs-btn-selected" disabled>Selected</button>'
      : '<button class="fccs-btn fccs-btn-add" data-variant-id="' + firstAvail.id + '">Add</button>';

    return '<div class="fccs-item" data-handle="' + product.handle + '">' +
      '<a class="fccs-img-link" href="/products/' + product.handle + '">' +
        '<img class="fccs-img" src="' + img + '" alt="' + product.title + '" loading="lazy" width="72" height="72">' +
      '</a>' +
      '<div class="fccs-info">' +
        '<a class="fccs-name" href="/products/' + product.handle + '">' + product.title + '</a>' +
        '<div class="fccs-prices">' +
          '<span class="fccs-price">' + price + '</span>' +
          (compare ? '<span class="fccs-compare">' + compare + '</span>' : '') +
        '</div>' +
        selectHtml +
      '</div>' +
      '<div class="fccs-btn-col">' + btnHtml + '</div>' +
    '</div>';
  }

  function addToCart(variantId, btn) {
    btn.textContent = '...';
    btn.classList.add('fccs-btn-loading');
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
    })
      .then(function (r) { if (!r.ok) throw new Error(); return r.json(); })
      .then(function () {
        btn.textContent = 'Selected';
        btn.className = 'fccs-btn fccs-btn-selected';
        btn.disabled = true;
        fetch('/cart.js')
          .then(function (r) { return r.json(); })
          .then(function (cartData) {
            window._fcdCart = cartData;
            if (typeof window.fcdRenderCart === 'function') {
              window.fcdRenderCart(cartData);
            }
          });
      })
      .catch(function () {
        btn.textContent = 'Add';
        btn.classList.remove('fccs-btn-loading');
      });
  }

  function attachListeners() {
    var widget = document.getElementById(WIDGET_ID);
    if (!widget) return;

    widget.querySelectorAll('.fccs-btn-add').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item      = btn.closest('.fccs-item');
        var sel       = item ? item.querySelector('[data-variant-select]') : null;
        var variantId = sel ? parseInt(sel.value, 10) : parseInt(btn.dataset.variantId, 10);
        addToCart(variantId, btn);
      });
    });

    widget.querySelectorAll('[data-variant-select]').forEach(function (sel) {
      sel.addEventListener('change', function () {
        var item = sel.closest('.fccs-item');
        if (!item) return;
        var btn = item.querySelector('.fccs-btn-add');
        if (btn) btn.dataset.variantId = sel.value;
      });
    });
  }

  function renderButtons(cartHandles) {
    var widget = document.getElementById(WIDGET_ID);
    if (!widget) return;
    widget.querySelectorAll('.fccs-item').forEach(function (item) {
      var handle = item.dataset.handle;
      var btn    = item.querySelector('.fccs-btn');
      if (!btn || btn.classList.contains('fccs-btn-loading')) return;
      var inCart = cartHandles.indexOf(handle) !== -1;
      if (inCart && !btn.classList.contains('fccs-btn-selected')) {
        btn.textContent = 'Selected';
        btn.className   = 'fccs-btn fccs-btn-selected';
        btn.disabled    = true;
      } else if (!inCart && btn.classList.contains('fccs-btn-selected')) {
        btn.textContent = 'Add';
        btn.className   = 'fccs-btn fccs-btn-add';
        btn.disabled    = false;
      }
    });
  }

  function renderFull(products, cartHandles) {
    var widget = document.getElementById(WIDGET_ID);
    if (!widget) return;
    if (!products.length) { widget.innerHTML = ''; return; }
    var html = products.map(function (p) {
      return buildCard(p, cartHandles.indexOf(p.handle) !== -1);
    }).join('');
    widget.innerHTML = '<p class="fccs-title">You May Also Like</p>' + html;
    attachListeners();
  }

  function loadAndRender(forceRefresh) {
    loadRules(function (r) {
      getCart(function (cartData) {
        var cartHandles = cartData.items.map(function (i) { return i.handle; });
        var handlesKey  = cartHandles.slice().sort().join(',');

        if (!forceRefresh && handlesKey === lastHandles && cachedProducts && lockedPicks) {
          renderButtons(cartHandles);
          return;
        }

        lastHandles = handlesKey;

        var pool = (r.default || []).slice();
        var triggers = r.triggers || {};
        cartHandles.forEach(function (handle) {
          if (triggers[handle]) {
            triggers[handle].forEach(function (extra) {
              if (pool.indexOf(extra) === -1) pool.push(extra);
            });
          }
        });

        var candidates = pool.filter(function (h) {
          return cartHandles.indexOf(h) === -1;
        });

        var candidatesKey = candidates.slice().sort().join(',');
        if (!lockedPicks || lockedPicks._key !== candidatesKey) {
          lockedPicks = pickRandomOnce(candidates, MAX_PRODUCTS);
          lockedPicks._key = candidatesKey;
          cachedProducts = null;
        }

        var picks = lockedPicks.filter(function (h) { return typeof h === 'string'; });

        fetchProducts(picks, function (products) {
          cachedProducts = products;
          renderFull(products, cartHandles);
        });
      });
    });
  }

  function inject() {
    if (injected) return;
    var anchor = document.querySelector(REBUY_BODY);
    if (!anchor) return;
    var widget = document.createElement('div');
    widget.id  = WIDGET_ID;
    widget.innerHTML = skeleton();
    anchor.appendChild(widget);
    injected = true;
    loadAndRender(true);
  }

  function watchInsideCart(anchor) {
    if (innerObs) { innerObs.disconnect(); innerObs = null; }
    innerObs = new MutationObserver(function () {
      if (!document.getElementById(WIDGET_ID)) {
        injected = false;
        setTimeout(inject, 100);
      }
    });
    innerObs.observe(anchor, { childList: true, subtree: true });
  }

  function watchCart() {
    var obs = new MutationObserver(function () {
      var flyout = document.querySelector(REBUY_FLYOUT);
      if (!flyout) return;
      var isOpen = flyout.classList.contains('is-open');
      if (isOpen) {
        var anchor = document.querySelector(REBUY_BODY);
        if (anchor && !injected) {
          setTimeout(function () { inject(); watchInsideCart(anchor); }, 200);
        }
      } else {
        if (innerObs) { innerObs.disconnect(); innerObs = null; }
        var w = document.getElementById(WIDGET_ID);
        if (w) w.remove();
        injected = false;
        // Keep lastHandles and lockedPicks — so same products show next open
      }
    });
    obs.observe(document.body, {
      childList: true, subtree: true,
      attributes: true, attributeFilter: ['class', 'style']
    });
  }

  function init() {
    injectStyles();
    watchCart();

    document.addEventListener('fcd:cart:handles:changed', function () {
      if (injected) loadAndRender(true);
    });

    document.addEventListener('theme:cart:change', function () {
      if (!injected) return;
      getCart(function (cartData) {
        var cartHandles = cartData.items.map(function (i) { return i.handle; });
        renderButtons(cartHandles);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();